import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

import { generateAutocompleteItems } from '../../../utils/helper';
import masterDataService from '../../../service/masterData.service';
import { useLoader } from '../../../provider/LoaderProvider';
import PhoneBase from '../../Interface/PhoneBase/PhoneBase';
import TabsUI from '../../Interface/TabsUI';
import InprogressInventoryTransfer from './InprogressInventoryTransfer';
import NewInventoryTransfer from './NewInventoryTransfer';

const InventoryTransferPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { showLoader, hideLoader } = useLoader();
  const [autocompleteData, setAutocompleteData] = useState({
    warehouse: [],
  });
  const [autocompleteOptions, setAutocompleteOptions] = useState({
    warehouse: [],
  });

  useEffect(() => {
    const loadAutocompleteData = async () => {
      showLoader();
      try {
        const warehouse = await masterDataService.warehouseToForm();

        setAutocompleteData({
          warehouse: Array.isArray(warehouse) ? warehouse : [],
        });
        setAutocompleteOptions({
          warehouse: generateAutocompleteItems(warehouse ?? [], ['code', 'name'], 'code'),
        });
      } finally {
        hideLoader();
      }
    };

    loadAutocompleteData();
  }, []);

  const tabs = [
    {
      id: 0,
      name: 'Új indítása',
      content: <NewInventoryTransfer autocompleteData={autocompleteData} autocompleteOptions={autocompleteOptions} />,
    },
    {
      id: 1,
      name: 'Folyamatban',
      content: <InprogressInventoryTransfer />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  return (
    <PhoneBase name="InventoryTransfer">
      <Typography variant="h5" sx={{ fontWeight: 400, py: 1, px: 2 }}>
        Készletáttárolás
      </Typography>
      <TabsUI activeTab={activeTab} handleTabClick={handleTabClick} disablePadding>
        {tabs.map((tab, index) => (
          <div key={index} name={tab.name}>
            {tab.content}
          </div>
        ))}
      </TabsUI>
    </PhoneBase>
  );
};

export default InventoryTransferPage;
